import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import './stores/rootStore.js';
import {BrowserRouter} from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import {loadStripe} from "@stripe/stripe-js";
import {Elements} from "@stripe/react-stripe-js";
import setupInterceptors from "./_helpers/axiosInterceptors.js";
import rootStore from "./stores/rootStore.js";

import "./_helpers/stripeConfig.js";

setupInterceptors(rootStore);

ReactDOM.createRoot(document.getElementById('root')).render(
      <BrowserRouter>
        <App/>
      </BrowserRouter>
)
